// src/composables/useDialog.js
import { ref } from 'vue';

export function useDialog(initialVisibility = false) {
    const isVisible = ref(initialVisibility);

    const openDialog = () => {
        isVisible.value = true;
    };

    const closeDialog = () => {
        isVisible.value = false;
    };

    const toggleDialog = () => {
        isVisible.value = !isVisible.value;
    };

    return {
        isVisible,
        openDialog,
        closeDialog,
        toggleDialog
    };
}
